module.exports = __webpack_public_path__ + "static/matt-mullenweg-0686111e6603460dd85a501e6b6b3fdf.jpg";